// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerB_TheComp__mBFS7"};